// extracted by mini-css-extract-plugin
export default {"loader":"Loader_loader__HWHmh","alternate":"Loader_alternate__2u+GK"};